// src/styles/formStyles.js
// Harmonized form styles with backwards-compatible export names.
// Export both modern names (field, chip, etc.) and legacy aliases (input, select, button).

export const baseFontFamily = "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial";

export const container = {
  fontFamily: baseFontFamily,
  color: "#172554",
  lineHeight: 1.4,
};

export const label = {
  display: "block",
  marginBottom: 8,
  color: "#2b4a84",
  fontWeight: 600,
  fontSize: 14,
};

export const field = {
  width: "100%",
  padding: "10px 12px",
  border: "2px solid #2b4a84",
  borderRadius: 8,
  boxSizing: "border-box",
  fontSize: 15,
  outline: "none",
  background: "#fff",
  transition: "box-shadow 150ms ease, border-color 150ms ease",
};

export const fieldFocus = {
  boxShadow: "0 6px 18px rgba(43,74,132,0.08)",
  borderColor: "#1f3f7a",
};

export const textarea = {
  ...field,
  minHeight: 96,
  resize: "vertical",
};

export const fieldWrapper = {
  marginBottom: 18,
};

export const hint = {
  color: "#6b7280",
  fontSize: 12,
  marginTop: 6,
};

export const btnPrimary = {
  background: "#2b4a84",
  color: "white",
  border: "none",
  padding: "8px 14px",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600,
};

export const btnNeutral = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "1px solid #cfcfcf",
  background: "white",
  cursor: "pointer",
};

export const smallMuted = { color: "#6b7280", fontSize: 12 };

/* Choice list (search results / lookup results) */
export const choiceList = {
  margin: 0,
  padding: 0,
  listStyle: "none",
  border: "1px solid #e6e9ef",
  borderRadius: 8,
  overflow: "hidden",
  background: "#fff",
  boxShadow: "0 6px 20px rgba(10,20,40,0.04)",
};

export const choiceItem = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: "12px 14px",
  borderBottom: "1px solid #f1f3f6",
  cursor: "pointer",
  transition: "background 120ms ease",
};

export const choiceItemHover = {
  background: "#f8fafc",
};

export const choiceItemSelected = {
  background: "#eef2ff",
  borderLeft: "4px solid #2b4a84",
  paddingLeft: 10,
};

export const choiceAvatar = {
  width: 40,
  height: 40,
  borderRadius: 6,
  background: "#f3f4f6",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 18,
  color: "#9aa6c7",
};

export const chip = {
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  padding: "6px 10px",
  borderRadius: 999,
  border: "1px solid #e6e9ef",
  background: "#fff",
  fontSize: 13,
};

/* -----------------------
   Backwards-compatible aliases
   - many files used FS.input previously; provide those names
   ----------------------- */

export const input = field;        // legacy alias used across project
export const select = field;       // if code expects select style
export const button = btnPrimary;  // alias for button style
export const textareaStyle = textarea; // alternate name if used elsewhere

/* default export optionally (not required) */
export default {
  baseFontFamily,
  container,
  label,
  field,
  fieldFocus,
  textarea,
  fieldWrapper,
  hint,
  btnPrimary,
  btnNeutral,
  smallMuted,
  choiceList,
  choiceItem,
  choiceItemHover,
  choiceItemSelected,
  choiceAvatar,
  chip,
  // aliases
  input,
  select,
  button,
  textareaStyle,
};
